import React from 'react'
import PropTypes from 'prop-types'
import {EmailSignup} from '@/components/email-signup'

export const BuilderEmailSignup = ({
    whiteMode,
    placement,
    attributes,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <EmailSignup
            whiteMode={whiteMode}
            placement={placement}
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'emailSignup-EmailSignup'}
        />
    )
}

BuilderEmailSignup.propTypes = {
    whiteMode: PropTypes.bool,
    placement: PropTypes.string.isRequired,
    attributes: PropTypes.any,
    'data-testid': PropTypes.string
}

export const EmailSignupDefinition = {
    component: BuilderEmailSignup,
    name: 'EmailSignup',
    noWrap: true,
    inputs: [
        {
            name: 'whiteMode',
            type: 'boolean',
            helperText: 'Applies white mode',
            defaultValue: false
        },
        {
            name: 'placement',
            type: 'string',
            required: true,
            helperText: 'Placement value of this component that will be used for tracking purposes.'
        }
    ]
}
